import { Button, Grid } from '@mui/material'
import React from 'react'
import VideoListCard from '../../../components/VideoListCard';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../../../hooks/useIsMobile';

function VideoLibraryControl() {

  const navigate = useNavigate();
  const mobile = useIsMobile();
  
  const navigateAddVideoPage = () => {
    navigate('/add-video');
  };

  const handleDeleteVideo = (recipeId) => {
    // Your delete logic here
    // console.log('Deleting video with ID:', recipeId);
  };

  return (
    <Grid sx={{ width: '100%', display: 'flex', flexDirection: 'column'}}>
      <Grid item display={'flex'} justifyContent={'center'} width={'100%'}>
        <Button 
          variant='contained' 
          color='primary' 
          sx={{ marginTop: '2rem', marginBottom: '2rem', width: '85%'}}
          onClick={navigateAddVideoPage}
        >
          Add Video
        </Button>
      </Grid>
      <Grid 
        item 
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center', // Change from 'center' to prevent centering content
          width: '100%',
          flexGrow: 1, // Add this
          overflow: 'auto', // Change from 'scroll' to 'auto'
          flexDirection: 'column',
          maxHeight: mobile ? '75dvh' : '65dvh',
          '&::-webkit-scrollbar': {
            width: '0.4em'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0,0,0,.1)',
            borderRadius: '24px'
          }
        }}
      >
        <VideoListCard 
          recipeTitle={'Testing New Recipe'}
          id={1}
          videoSrc={'https://res.cloudinary.com/djrbfvpit/video/upload/v1722272714/DesktopDemoGPTOrganized_sjpfwd.mp4'}
          handleDeleteVideo={handleDeleteVideo}
        />
        <VideoListCard 
          recipeTitle={'Testing New Recipe'}
          id={1}
          videoSrc={'https://res.cloudinary.com/djrbfvpit/video/upload/v1722272714/DesktopDemoGPTOrganized_sjpfwd.mp4'}
          handleDeleteVideo={handleDeleteVideo}
        />
        <VideoListCard 
          recipeTitle={'Testing New Recipe'}
          id={1}
          videoSrc={'https://res.cloudinary.com/djrbfvpit/video/upload/v1722272714/DesktopDemoGPTOrganized_sjpfwd.mp4'}
          handleDeleteVideo={handleDeleteVideo}
        />
        <VideoListCard 
          recipeTitle={'Testing New Recipe'}
          id={1}
          videoSrc={'https://res.cloudinary.com/djrbfvpit/video/upload/v1722272714/DesktopDemoGPTOrganized_sjpfwd.mp4'}
          handleDeleteVideo={handleDeleteVideo}
        />
        <VideoListCard 
          recipeTitle={'Testing New Recipe'}
          id={1}
          videoSrc={'https://res.cloudinary.com/djrbfvpit/video/upload/v1722272714/DesktopDemoGPTOrganized_sjpfwd.mp4'}
          handleDeleteVideo={handleDeleteVideo}
        />
      </Grid>
    </Grid>
  )
}

export default VideoLibraryControl;